import { CommonModule } from "@angular/common";
import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { ISubscription } from "@rfm/shared-interfaces";
import { MenuItem } from "primeng/api";
import { BreadcrumbModule } from "primeng/breadcrumb";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { SubscriptionService } from "../../../../shared/services/products/subscription.service.mjs";

@Component({
  selector: "app-subscription-view",
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BreadcrumbModule,
    CardModule,
    ButtonModule,
    ProgressSpinnerModule,
  ],
  templateUrl: "./subscription-view.component.html",
  styleUrls: ["./subscription-view.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class SubscriptionViewComponent implements OnInit {
  object: ISubscription | null = null; // Store the selected conduit details
  isLoading = false;

  breadCrumbItems: MenuItem[] | undefined;

  home: MenuItem | undefined;

  constructor(
    private route: ActivatedRoute,
    private service: SubscriptionService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.home = { icon: "pi pi-home", routerLink: "/" };
    const id = this.route.snapshot.paramMap.get("id");
    if (id) {
      this.load(id);
    }
  }

  load(id: string): void {
    this.isLoading = true;
    this.service
      .get(id)
      .then((response) => {
        this.object = response?.data ?? null; // Handle null or undefined data
      })
      .catch((error) => {
        console.error("Error fetching subscription details:", error);
      })
      .finally(() => {
        this.breadCrumbItems = [
          {
            label: "Customers",
            command: () => this.router.navigate(["/admin/customers"]),
          },
          {
            label: this.object?.customer_id.name ?? "Customer",
            command: () =>
              this.router.navigate([
                "/admin/customers/view",
                this.object?.customer_id.id,
              ]),
          },
          {
            label: "Subscriptions",
            command: () => this.router.navigate(["/admin/subscriptions"]),
          },
          {
            label: "Subscription",
          },
        ];
        this.isLoading = false;
      });
  }
}
